import { normalizeLanguage } from '@rover/constants/src/i18n/language';
import { Language } from '@rover/constants/src/i18n/lingui.constants';
import {
  CountryUrlPrefix,
  getDefaultShortLanguageByUrlPrefix,
  getShortLanguagesByUrlPrefix,
} from '@rover/utilities/roverGeo.constants';

export type SeoLocationDescriptor = {
  countryUrlPrefix: string;
  language: Language;
  citySlug: string;
  regionSlug: string;
  serviceTypeSlug: string;
  neighborhoodSlug?: string;
};

function getSeoLocationParts(
  seoLocationSegment: string
): [undefined, string, string, string] | [string, string, string, string] {
  const seoLocationParts: Array<string | undefined> = seoLocationSegment.split('--');
  if (seoLocationParts.length === 3) seoLocationParts.unshift(undefined);
  return seoLocationParts as [undefined, string, string, string] | [string, string, string, string];
}

export function parseSeoLocationFromSegments(
  countryUrlPrefixSegment: string | undefined,
  languageSegment: string | undefined,
  seoLocationSegment: string
): SeoLocationDescriptor {
  const countryUrlPrefix = (countryUrlPrefixSegment ?? 'us') as CountryUrlPrefix;
  const shortLanguage = normalizeLanguage(languageSegment);
  const language =
    shortLanguage && getShortLanguagesByUrlPrefix(countryUrlPrefix).includes(shortLanguage)
      ? shortLanguage
      : getDefaultShortLanguageByUrlPrefix(countryUrlPrefix);

  const [neighborhoodSlug, citySlug, regionSlug, serviceTypeSlug] =
    getSeoLocationParts(seoLocationSegment);

  return {
    countryUrlPrefix,
    language,
    citySlug,
    regionSlug,
    serviceTypeSlug,
    neighborhoodSlug,
  };
}
